export default "__VITE_ASSET__Cshz3EzW__"